// History-API router: current path, pattern matching and in-app navigation.
import { h, redraw } from "./ui";

export const route = { path: location.pathname, query: new URLSearchParams(location.search) };

const listeners: Array<() => void> = [];
export function onNavigate(fn: () => void) {
  listeners.push(fn);
}

function sync() {
  route.path = location.pathname;
  route.query = new URLSearchParams(location.search);
  for (const fn of listeners) fn();
  redraw();
}

addEventListener("popstate", sync);

export function navigate(to: string, opts: { replace?: boolean } = {}) {
  if (to === location.pathname + location.search) return;
  if (opts.replace) history.replaceState(null, "", to);
  else history.pushState(null, "", to);
  scrollTo(0, 0);
  sync();
}

/** Matches "/admin/homes/:id" against the current path; returns params or null. */
export function match(pattern: string, path = route.path): Record<string, string> | null {
  const p = pattern.split("/").filter(Boolean);
  const s = path.split("/").filter(Boolean);
  if (p.length !== s.length) return null;
  const params: Record<string, string> = {};
  for (let i = 0; i < p.length; i++) {
    if (p[i].startsWith(":")) params[p[i].slice(1)] = decodeURIComponent(s[i]);
    else if (p[i] !== s[i]) return null;
  }
  return params;
}

export function startsWith(prefix: string) {
  return route.path === prefix || route.path.startsWith(prefix + "/");
}

/** In-app link: plain <a href> that navigates without a page load. */
export function Link(props: { href: string; class?: string; style?: string; children?: any; "aria-current"?: string; title?: string; download?: boolean }) {
  const { href, children, ...rest } = props;
  return h(
    "a",
    {
      ...rest,
      href,
      onClick: (e: MouseEvent) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        navigate(href);
      },
    },
    children,
  );
}
